var slider = new KeenSlider(".product-features__slider", {
  loop: true,
  breakpoints: {
    '(max-width: 449px)': {
      slides: {
        perView: 1.5,
        spacing: 16
      }
    },
    '(min-width: 450px)': {
      slides: {
        perView: 2,
        spacing: 20
      }
    },
    '(min-width: 990px)': {
      disabled: true,
    },
  },
}, [navigation]);